// Load all the channels within this directory and all subdirectories.
// Channel files must be named *_channel.js.

const channels = require.context('.', true, /_channel\..+$/)
channels.keys().forEach(channels)

// Explicitly import the plaid report status channel to ensure it's loaded
import './plaid_report_status_channel'
